import {
    Baseline,
    Brain,
    ChartArea,
    ChartLine,
    ChartScatter,
    Columns2,
    Columns3,
    Columns4,
    Eraser,
    Gauge,
    GripHorizontal,
    GripVertical,
    ImageUpscale,
    Minus,
    PanelRight,
    PictureInPicture,
    SeparatorHorizontal,
    Square,
    Type,
    WandSparkles,
} from 'lucide-vue-next'

import { createSingleIconVariants } from '@/vue/components/design-system/icon/helpers/iconVariants'

export const lucideIcons = {
    'grip-horizontal': createSingleIconVariants(GripVertical),
    'grip-vertical': createSingleIconVariants(GripHorizontal),
    'panel-right': createSingleIconVariants(PanelRight),
    'minimize': createSingleIconVariants(Minus),
    'pip': createSingleIconVariants(PictureInPicture),
    'image-upscale': createSingleIconVariants(ImageUpscale),
    'wand-sparkles': createSingleIconVariants(WandSparkles),
    'brain': createSingleIconVariants(Brain),
    'gauge': createSingleIconVariants(Gauge),
    'eraser': createSingleIconVariants(Eraser),
    'columns-3': createSingleIconVariants(Columns3),
    'columns-2': createSingleIconVariants(Columns2),
    'columns-4': createSingleIconVariants(Columns4),
    'square': createSingleIconVariants(Square),
    'baseline': createSingleIconVariants(Baseline),
    'separator-horizontal': createSingleIconVariants(SeparatorHorizontal),
    'typopgraphy': createSingleIconVariants(Type),
    'chart-line': createSingleIconVariants(ChartLine),
    'chart-area': createSingleIconVariants(ChartArea),
    'chart-scatter': createSingleIconVariants(ChartScatter),
}
